import React from "react";
import MenuBar from "../components/menuBarLoggedIn/menuBarLoggedIn.jsx";
import "../styles/FAQpage.css";
import yellowQuestionBg from "../assets/svgs/question-mark-yellow-bg.svg";
import downChevron from "../assets/svgs/down-chevron.svg";
import Footer from "../components/footer";


const FAQpage = () => {
  const collection = document.getElementsByClassName('tickets');
    // turn the collection into an array
    const myElements = Array.from(collection);

    // loop through the collection of elements
    // and style each element
    myElements.forEach((element) => {
      // element.style.backgroundColor = 'blue';
    });
  return (
    <>
      <div>
        <MenuBar/>
        <main className="faq-main">
            <span>
                <h1>Frequently Asked Questions</h1>
                <img src={yellowQuestionBg} alt="" />
            </span>
            <p>Have questions ? Don’t worry we’re here to help.</p>
            <section className="faqs">
                <section className="tickets">
                  <h1>Tickets</h1>
                  <div className="faq">
                    <div className="question">
                      <p>How do I purchase a bus ticket?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Can I purchase a bus ticket in advance?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>What type of payment do we accept for bus tickets?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>What is your refund policy for bus tickets?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>How do I receive my bus tickets after purchase?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>What should I do if I don’t receive my bus ticket confirmation?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Can I transfer my bus ticket to another person?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Is there assigned seating on the buses booked through Shuttle9ja?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>What is he baggage allowance for bus tickets purchased through Shuttle9ja?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                </section>

                <section className="payments">
                  <h1>Payments</h1>
                  <div className="faq">
                    <div className="question">
                      <p>What payment methods do you accept for bus ticket purchase?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Is it safe to use my credit/debit card on Shutttle9ja?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Are there any additional fees or charges for using a specific payment method?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>How do I update my payment information on my Shuttle9ja account?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Can I split payment for a bus ticket purchase with another person?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>How do I know if my payment was successful?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>What should I do if I receive an error message while trying to make a payment?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Is there a limit to the amount I can send on a single transaction?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Can I receive a refund if I paid for my bus ticket using a certain payment method?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                </section>

                <section className="bookings">
                  <h1>Bookings</h1>
                  <div className="faq">
                    <div className="question">
                      <p>How do I book a bus ticket on Shuttle9ja?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Can I make changes or cancel my booking after it has been confirmed?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>How do I know if my booking was successful?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Can I book a bus ticket for someone else using my account?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>What should I do if I don’t receive my booking confirmation email?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Can I book a return trip on Shuttle9ja?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>How far in advance can I make a booking?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>How do I view or download my booking details?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                  <div className="faq">
                    <div className="question">
                      <p>Is it possible to upgrade my ticket to a higher class after booking?</p>
                      <img src={downChevron} alt="" />
                    </div>
                    <div className="answer">
                      <p></p>
                    </div>
                  </div>
                </section>
                
                <section className="payments"></section>
                <section className="bookings"></section>
            </section>
        </main>
       <Footer />
      </div>
    </>
  );
};
export default FAQpage;